import { Typography } from '@design-system/components/typography/typography';
import * as styles from './FeatureSection.css';
import { Button } from '@design-system/components/button/button';
import { Col } from '@design-system/components/grid/grid';
import clsx from 'clsx';

type FeatureSectionProps = {
  title: string;
  description: string;
  ctaText: string;
  onClick: () => void;
  imageSrc: string;
  reverse?: boolean;
};

export const FeatureSection = (p: FeatureSectionProps) => {
  return (
    <div className={clsx(styles.wrapper, p.reverse && styles.reverse)}>
      <Col gap="xl">
        <Typography variant="display" size="small">
          {p.title}
        </Typography>
        <Typography variant="title" size="large" className={styles.textWrapper}>
          {p.description}
        </Typography>
        <div>
          <Button variant="filled" color="primary" onClick={p.onClick}>
            {p.ctaText}
          </Button>
        </div>
      </Col>
      <div>
        <img src={p.imageSrc} alt="" />
      </div>
    </div>
  );
};
